import React, { useState, useEffect } from 'react';
import {
    Sidebar, SidebarNav, SidebarLayout,
    Container, RowView, Col, Navbar, Heading, Paragraph,
    Button, CardView, Image, Input, Spacer,
    Alert, Badge, ListView, ListItem, Flex, Grid,
    Table, Progress, Spinner, Dropdown, Link,
    Modal, Tabs, Divider, Text,
    useResponsive, MobileOnly, DesktopOnly, Body
} from '../layouts/MainCompontes/index';
import { Nav } from 'react-bootstrap';
import '../layouts/MainCompontes/MainComponents.css';
import ImageShow from '../Uitiles/ImageShow';
import { useSettings } from '../context/SettingsContext';
import useOs from '../hooks/Os';

const TaskManage = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedPage, setSelectedPage] = useState('dashboard');
    const [notifications, setNotifications] = useState(5);
    const [isAtTop, setIsAtTop] = useState(true);  // State to track if we're at the top
    const platformInfo = useOs();
    const [showSidebar, setShowSidebar] = useState(false);
    // Use responsive hook
    const screen = useResponsive();
    const { settings } = useSettings();

    // Initialize platform on mount (works even without Capacitor installed)
    React.useEffect(() => {
        const initPlatform = async () => {
            try {
                const { initializeCapacitor } = await import('./index');
                await initializeCapacitor();
            } catch (error) {
                console.log('Running without Capacitor:', error.message);
            }
        };
        initPlatform();
    }, []);

    // Sidebar navigation items
    const sidebarItems = [
        {
            icon: '🏠',
            label: 'Dashboard',
            key: 'dashboard',
            active: selectedPage === 'dashboard'
        },
        {
            icon: '📊',
            label: 'Analytics',
            key: 'analytics',
            badge: 'Pro',
            badgeColor: '#28a745'
        },
        {
            icon: '👥',
            label: 'Users',
            key: 'users',
            badge: '1.2k',
            badgeColor: '#007bff'
        },
        {
            icon: '📦',
            label: 'Products',
            key: 'products'
        },
        { divider: true },
        { header: 'Management' },
        {
            icon: '⚙️',
            label: 'Settings',
            key: 'settings'
        },
        {
            icon: '📝',
            label: 'Reports',
            key: 'reports'
        },
        {
            icon: '💬',
            label: 'Messages',
            key: 'messages',
            badge: notifications,
            badgeColor: '#dc3545'
        },
        { divider: true },
        {
            icon: '❓',
            label: 'Help & Support',
            key: 'help'
        }
    ];

    // Stats data
    const stats = [
        {
            title: 'Total Tasks',
            value: '100',
            change: '+12.5%',
            changeType: 'positive',
            icon: '💰',
            bg: 'primary'
        },
        {
            title: 'Completed Tasks',
            value: '50',
            change: '+8.2%',
            changeType: 'positive',
            icon: '👥',
            bg: 'success'
        },
        {
            title: 'Pending Tasks',
            value: '50',
            change: '-3.1%',
            changeType: 'negative',
            icon: '📦',
            bg: 'warning'
        },
        {
            title: 'Cancelled Tasks',
            value: '0',
            change: '+1.2%',
            changeType: 'positive',
            icon: '📈',
            bg: 'info'
        }
    ];

    // Recent orders data
    const recentOrders = [
        { id: '#12345', customer: 'John Doe', product: 'Product A', amount: '$125.00', status: 'Completed' },
        { id: '#12346', customer: 'Jane Smith', product: 'Product B', amount: '$89.50', status: 'Pending' },
        { id: '#12347', customer: 'Bob Johnson', product: 'Product C', amount: '$220.00', status: 'Completed' },
        { id: '#12348', customer: 'Alice Williams', product: 'Product D', amount: '$156.75', status: 'Processing' },
        { id: '#12349', customer: 'Charlie Brown', product: 'Product E', amount: '$99.00', status: 'Completed' }
    ];

    // Recent activities
    const activities = [
        { icon: '✅', text: 'New order received', time: '2 minutes ago', type: 'success' },
        { icon: '👤', text: 'New user registered', time: '15 minutes ago', type: 'info' },
        { icon: '📦', text: 'Product updated', time: '1 hour ago', type: 'primary' },
        { icon: '💬', text: 'New message from support', time: '2 hours ago', type: 'warning' },
        { icon: '🔔', text: 'System maintenance scheduled', time: '5 hours ago', type: 'danger' }
    ];

    const handleNavSelect = (key) => {
        setSelectedPage(key);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);  // Add scroll event listener
        return () => window.removeEventListener('scroll', handleScroll);  // Cleanup the event listener when the component is unmounted
    }, []);

    const handleScroll = () => {
        if (window.scrollY === 0) {
            setIsAtTop(true);  // If the scroll position is at the top, set state to true
        } else {
            setIsAtTop(false);  // If scrolled down, set state to false
        }
    };

    return (
        <>
            <Body>
                {/* Main Dashboard Content */}
                <div className="">
                    {/* Welcome Alert */}
                    <Alert variant="info" dismissible>
                        <strong>👋 Welcome back!</strong> You have {notifications} new notifications.
                    </Alert>

                    <Spacer height="30px" />

                    
                        <CardView title="" subtitle="">
                            <Flex justify="space-between" align="center">
                                <div>
                                    <Heading level={2} style={{ textAlign: 'left' }}>Task Management</Heading>
                                    <Text>Welcome to the Task Management System</Text>
                                </div>
                                <Flex justify="space-between" align="center" style={{ gap: 10 }}>
                                    <Button variant="primary">Add Task</Button>
                                    <Button variant="secondary">View All Tasks</Button>
                                </Flex>
                            </Flex>
                        </CardView>
                    

                    {/* Stats Cards */}
                    <RowView xs={1} sm={2} lg={4} className="gap-1">
                        {stats.map((stat, index) => (
                            <Col key={index}>
                                <CardView
                                    bg={stat.bg}
                                    text="white"
                                    style={{ height: '100%' }}
                                >
                                    <Flex justify="space-between" align="center">
                                        <div>
                                            <Text tag="div" style={{ fontSize: '14px', opacity: 0.9 }}>
                                                {stat.title}
                                            </Text>
                                            <Heading level={2} style={{ margin: '10px 0', color: 'white' }}>
                                                {stat.value}
                                            </Heading>
                                            <Badge
                                                bg={stat.changeType === 'positive' ? 'success' : 'danger'}
                                                style={{ fontSize: '12px' }}
                                            >
                                                {stat.change}
                                            </Badge>
                                        </div>
                                        <div style={{ fontSize: '40px', opacity: 0.8 }}>
                                            {stat.icon}
                                        </div>
                                    </Flex>
                                </CardView>
                            </Col>
                        ))}
                    </RowView>

                    <Spacer height="30px" />

                    {/* Recent Orders Table */}
                    <CardView title="Recent Tasks" subtitle="Latest tasks">
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Task ID</th>
                                    <th>Task Name</th>
                                    <th>Task Description</th>
                                    <th>Task Status</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentOrders.map((order, index) => (
                                    <tr key={index}>
                                        <td><strong>{order.id}</strong></td>
                                        <td>{order.customer}</td>
                                        <td>{order.product}</td>
                                        <td><strong>{order.amount}</strong></td>
                                        <td>
                                            <Badge
                                                bg={
                                                    order.status === 'Completed' ? 'success' :
                                                        order.status === 'Pending' ? 'warning' :
                                                            'info'
                                                }
                                            >
                                                {order.status}
                                            </Badge>
                                        </td>
                                        <td>
                                            <Flex gap="5px">
                                                <Button variant="outline-primary" size="sm">
                                                    View
                                                </Button>
                                                <Button variant="outline-secondary" size="sm">
                                                    Edit
                                                </Button>
                                            </Flex>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <Spacer height="15px" />
                        <Flex justify="space-between" align="center">
                            <Text>Showing 5 of 892 orders</Text>
                            <Button variant="primary">View All Orders</Button>
                        </Flex>
                    </CardView>



                    <Spacer height="50px" />
                </div>

                {/* New Order Modal */}
                <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    title="Create New Order"
                    size="lg"
                    footer={
                        <Flex gap="10px" justify="end">
                            <Button variant="secondary" onClick={() => setShowModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={() => {
                                alert('Order created!');
                                setShowModal(false);
                            }}>
                                Create Order
                            </Button>
                        </Flex>
                    }
                >
                    <Input
                        label="Customer Name"
                        type="text"
                        placeholder="Enter customer name"
                        required
                    />
                    <Input
                        label="Product"
                        type="text"
                        placeholder="Enter product name"
                        required
                    />
                    <Input
                        label="Quantity"
                        type="number"
                        placeholder="Enter quantity"
                        required
                    />
                    <Input
                        label="Amount"
                        type="text"
                        placeholder="Enter amount"
                        required
                    />
                    <Input
                        label="Notes"
                        as="textarea"
                        rows={3}
                        placeholder="Additional notes..."
                    />
                </Modal>
            </Body>


        </>
    );
};

export default TaskManage;

